"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filtersSetValue = exports.filtersReduce = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var filtersReduce = function filtersReduce(filtersValue, pickedFiltersKeysPrev) {
  var pickedFilters = Array.isArray(filtersValue) ? filtersValue.reduce(function (pickedFilters, filter) {
    if (filter.value) {
      if (Array.isArray(filter.value) && filter.value.length < 1) {
        return pickedFilters;
      }
      if (filter.id === "capacity" && filter.isConverted) {
        filter = _objectSpread(_objectSpread({}, filter), {}, {
          isConverted: false,
          value: {
            from: filter.value.from * 1000,
            to: filter.value.to * 1000
          }
        });
      }
      pickedFilters[filter.id] = filter.value;
    }
    return pickedFilters;
  }, {}) : filtersValue;
  var pickedFiltersKeys = Object.keys(pickedFilters);
  var newlyPickedFilterKey = pickedFiltersKeys.length === 1 ? pickedFiltersKeys[0] : pickedFiltersKeys.find(function (key) {
    return pickedFiltersKeysPrev.includes(key);
  });
  return {
    pickedFilters: pickedFilters,
    pickedFiltersKeys: pickedFiltersKeys,
    newlyPickedFilterKey: newlyPickedFilterKey
  };
};
exports.filtersReduce = filtersReduce;
var filtersSetValue = function filtersSetValue(filters, filtersValue, newlyPickedFilterKey, pickedFiltersKeys) {
  filters === null || filters === void 0 ? void 0 : filters.forEach(function (filter) {
    var _filtersValue$find3;
    if (newlyPickedFilterKey === filter.id) {
      var _filtersValue$find, _filtersValue$find2;
      return pickedFiltersKeys.length === 1 ? _objectSpread(_objectSpread({}, filters.find(function (pickedFilter) {
        return pickedFilter.id === filter.id;
      })), {}, {
        value: (_filtersValue$find = filtersValue.find(function (pickedFilter) {
          return pickedFilter.id === filter.id;
        })) === null || _filtersValue$find === void 0 ? void 0 : _filtersValue$find.value
      }) : _objectSpread(_objectSpread({}, filter), {}, {
        value: (_filtersValue$find2 = filtersValue.find(function (pickedFilter) {
          return pickedFilter.id === filter.id;
        })) === null || _filtersValue$find2 === void 0 ? void 0 : _filtersValue$find2.value
      });
    }
    return _objectSpread(_objectSpread({}, filter), {}, {
      value: (_filtersValue$find3 = filtersValue.find(function (pickedFilter) {
        return pickedFilter.id === filter.id;
      })) === null || _filtersValue$find3 === void 0 ? void 0 : _filtersValue$find3.value
    });
  });
  return filters;
};
exports.filtersSetValue = filtersSetValue;